import React, { useEffect } from "react";

export interface MetaTag {
  name?: string;
  content?: string;
}

export interface CharsetTag {
  charset: string;
}

export interface HttpEquivTag {
  httpEquiv: string;
  content: string;
}

export interface MetaTagsProps {
  title?: string;
  language?: string;
  metaTags?: MetaTag[];
  charsetTags?: CharsetTag[];
  httpEquivTags?: HttpEquivTag[];
}

const useMetaTags = ({ title, language, metaTags, charsetTags, httpEquivTags }: MetaTagsProps) => {
  useEffect(() => {
    if (title) {
      document.title = title;
    }

    if (language) {
      document.documentElement.lang = language;
    }

    if (metaTags) {
      metaTags.forEach(({ name, content }) => {
        let metaElement = document.head.querySelector(`meta[name="${name}"]`) as HTMLMetaElement;

        if (!metaElement) {
          metaElement = document.createElement("meta");
          metaElement.name = name ? name : "";
          document.head.appendChild(metaElement);
        }

        metaElement.content = content ? content : "";
      });
    }

    if (charsetTags) {
      charsetTags.forEach(({ charset }) => {
        let charsetElement = document.head.querySelector("meta[charset]");

        if (!charsetElement) {
          charsetElement = document.createElement("meta");
          document.head.appendChild(charsetElement);
        }

        charsetElement.setAttribute("charset", charset);
      });
    }

    if (httpEquivTags) {
      httpEquivTags.forEach(({ httpEquiv, content }) => {
        let httpEquivElement = document.head.querySelector(`meta[http-equiv="${httpEquiv}"]`) as HTMLMetaElement;

        if (!httpEquivElement) {
          httpEquivElement = document.createElement("meta");
          document.head.appendChild(httpEquivElement);
        }

        httpEquivElement.content = content;
        httpEquivElement.httpEquiv = httpEquiv;
      });
    }
  }, [title, language, metaTags, charsetTags, httpEquivTags]);
};

export { useMetaTags };
